import { useState } from "react";
import { validateImportMapping, type ImportColumn, type ImportField } from "@easy-core/spreadsheet";

export function ImportColumnMapping({ columns, fields, busy, onApply }: {
  columns: ImportColumn[];
  fields: ImportField[];
  busy: boolean;
  onApply: (mapping: string[]) => void;
}) {
  const [mapping, setMapping] = useState(() => columns.map(column => column.target));
  const errors = validateImportMapping(mapping, fields);
  return (
    <section className="import-column-mapping" aria-label="Correspondance des colonnes">
      <h3>Vérifier les colonnes</h3>
      <p className="muted">Les correspondances reconnues sont proposées automatiquement. Choisissez un champ pour les autres colonnes, ou ignorez-les. Les champs obligatoires sont marqués d’un astérisque.</p>
      <div className="import-mapping-table">
        <table>
          <thead><tr><th>Colonne du fichier</th><th>Exemples</th><th>Champ de destination</th></tr></thead>
          <tbody>{columns.map((column, index) => (
            <tr key={index}>
              <td data-label="Colonne du fichier"><strong>{column.label}</strong>{!mapping[index] ? <div className="muted">Colonne ignorée</div> : null}</td>
              <td data-label="Exemples">{column.examples.join(" · ") || "—"}</td>
              <td data-label="Champ de destination"><select aria-label={`Correspondance : ${column.label} (colonne ${index + 1})`} value={mapping[index]} disabled={busy}
                onChange={event => setMapping(current => current.map((key, position) => position === index ? event.target.value : key))}>
                <option value="">Ignorer cette colonne</option>
                {fields.map(field => <option key={field.key} value={field.key}>{field.label}{field.required ? (field.requiredUnless ? " * (création)" : " *") : ""}</option>)}
              </select></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      {errors.length ? <div role="alert">{errors.map(error => <p key={error}>{error}</p>)}</div> : null}
      <button type="button" className="button button-primary" disabled={busy || errors.length > 0} onClick={() => onApply(mapping)}>
        {busy ? "Analyse en cours…" : "Prévisualiser les lignes"}
      </button>
    </section>
  );
}
